<template>

</template>
<script>
    export default {
        components: {},
        props: {
            type: {
                type: String,
                default: 'success'
            },
            message: {
                type: String,
                default: null
            }
        },
        data() {
            return {

            }
        },
        methods: {

        },
        beforeMount() {
            const self = this;

            self.$snotify[self.type](self.message, (self.type.charAt(0).toUpperCase() + self.type.slice(1)));
        }
    }
</script>